<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import Modal from 'dashboard/components/Modal.vue';
import ModalHeader from 'dashboard/components/ModalHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  imageSrc: {
    type: String,
    default: null,
  },
  aspectRatio: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['close', 'save']);

const cropperRef = ref(null);
const { t } = useI18n();

const handleClose = () => {
  emit('close');
};

const handleSave = () => {
  if (cropperRef.value) {
    const { canvas } = cropperRef.value.getResult();
    if (canvas) {
      canvas.toBlob(blob => {
        emit('save', blob);
      }, 'image/png');
    }
  }
};
</script>

<template>
  <Modal :show="show" :on-close="handleClose">
    <ModalHeader
      :header-title="t('IMAGE_CROPPER.TITLE')"
      :header-content="t('IMAGE_CROPPER.DESCRIPTION')"
    />
    <div class="p-4">
      <div class="w-full h-64 bg-n-slate-2 flex items-center justify-center">
        <Cropper
          ref="cropperRef"
          :src="imageSrc"
          class="w-full h-full"
          :stencil-props="{
            handlers: {},
            movable: true,
            resizable: true,
            aspectRatio: aspectRatio,
          }"
        />
      </div>
      <div class="flex justify-end gap-2 mt-4">
        <NextButton
          variant="outline"
          :label="t('IMAGE_CROPPER.CANCEL')"
          @click="handleClose"
        />
        <NextButton blue :label="t('IMAGE_CROPPER.SAVE')" @click="handleSave" />
      </div>
    </div>
  </Modal>
</template>
